<!-- eslint-disable max-len -->
<template>
  <div class="d-flex flex-column">
    <!-- Screen Mode & Save -->
    <div
      :class="{ 'screen-mode-and-save-scroll': isScroll }"
      class="screen-mode-and-save justify-content-end"
    >
      <div class="wrap-screen-mode justify-content-end">
        <button
          class="save-button"
          @click="submitForm">
          Save
        </button>
      </div>
    </div>

    <!-- Card View Information -->
    <div class="card-page">
      <div class="card-page-content input-field">
        <h6 class="card-title-text">View Information</h6>

        <b-row>
          <b-col cols="12">
            <b-form :class="{'error-input' : $v.dataSetup.title.$error}">
              <label>Title <span style="color:red">*</span></label>
              <j-input
                v-model="dataSetup.title"
                placeholder="Enter title here"/>
            </b-form>
          </b-col>
          <b-col cols="12">
            <b-form :class="{'error-input' : $v.dataSetup.sheet_name.$error}">
              <label>Sheet Name</label>
              <j-input
                v-model="dataSetup.sheet_name"
                placeholder="Enter sheet name here"/>
            </b-form>
          </b-col>
          <b-col cols="12">
            <b-form v-if="!dataSetup.is_use_advance_report">
              <label>Format File</label>
              <j-single-select
                v-model="$v.dataSetup.format_file.$model"
                :options="listFormatFile"
                placeholder="Select Format File"/>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Card Advance Report -->
    <div
      v-if="advanceReportSetting && !isExternalApi"
      class="card-page m__t--25"
    >
      <div class="card-page-content input-field">
        <h6 class="card-title-text">Advance Report</h6>

        <div class="card-toggle-config">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h4 class="title-config">Advance Import</h4>
              <p class="description mb-0">
                Support for importing big data to table Data Manager and including monitoring reports
              </p>
            </div>
            <j-switch v-model="dataSetup.is_use_advance_report"/>
          </div>
        </div>

        <b-form
          v-if="dataSetup.is_use_advance_report"
          class="mt-3"
        >
          <label>Format File</label>
          <j-single-select
            v-model="$v.dataSetup.format_file.$model"
            :disabled="true"
            :options="listFormatFileAdvanceReport"
            :error-required="false"
            placeholder="Select Format File"
          />
        </b-form>
      </div>
    </div>

    <!-- Card Column List -->
    <div class="card-page m__t--25">
      <div class="card-page-content input-field">
        <h6 class="card-title-text">Column</h6>

        <section>
          <draggable
            v-model="dataSetup.columns"
            :options="{
              animation:300,
              handle:'.icon-drag'
            }"
            class="row"
          >
            <b-col
              v-for="(data, index) in dataSetup.columns"
              :key="index + 0"
              cols="12"
            >
              <div class="field-list py-3 mb-2">
                <div class="d-flex align-items-center">
                  <img
                    src="@/assets/new-form-ui/dragged.svg"
                    class="icon-drag"
                  >

                  <b-row>
                    <b-col cols="6 pr-0">
                      <j-input
                        v-model="data.name"
                        :error-required="false"
                        placeholder="Column name"
                      />
                    </b-col>
                    <b-col cols="6">
                      <j-single-select
                        v-model="data.key"
                        :options="variableOptionsClass"
                        :error-required="false"
                        :placeholder="'Select Variable'"
                      />
                    </b-col>
                  </b-row>

                  <i
                    class="fa fa-trash ml-3 cursor-pointer"
                    @click="deleteColumn(index)"
                  />
                </div>
              </div>
            </b-col>
          </draggable>
        </section>

        <div
          class="btn-add-more"
          @click="addColumn"
        >
          <img
            :src="require('@/assets/icon/add.png')"
            class="m__r--5"
            height="15"
            width="15">
          Add Column
        </div>
      </div>
    </div>

    <!-- Delete View -->
    <div class="card-transparent m__t--15">
      <span
        v-if="formDetail.import_view"
        class="cursor-pointer"
        style="font-size: 14px"
        @click="deleteView"
      >
        <i class="fa fa-trash"/> <small>Delete this view</small>
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-nested-ternary, no-console, camelcase, func-names, consistent-return */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import jSwitch from '@/components/inputs/jSwitch';
// Mixins
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jMixScroll from '@/mixins/form-ui-v2/jMixScroll';
import jMixToolbox from '@/mixins/form-ui-v2/jMixToolbox';

export default {
  components: {
    draggable,
    jSwitch,
  },

  mixins: [jMixAutoScroll, jMixScroll, jMixToolbox],

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },

  validations: {
    dataSetup: {
      title: { required },
      sheet_name: {},
      format_file: {},
      columns: {},
    },
  },

  data() {
    return {
      isLoading: true,
      dataSetup: {
        title: null,
        sheet_name: null,
        format_file: null,
        columns: [],
        is_use_advance_report: false,
      },
      advanceReportSetting: false,
      variableOptionsClass: [],
      listFormatFile: [
        { id: 'xls', text: 'XLS' },
        { id: 'xlsx', text: 'XLSX' },
      ],
      listFormatFileAdvanceReport: [
        { id: 'csv', text: 'CSV' },
      ],
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),

    isExternalApi() {
      return this.formDetail.type === 'external_url';
    },

    genData() {
      const { title, sheet_name, format_file, columns, is_use_advance_report } = this.dataSetup;

      const params = this._.cloneDeep(this.formDetail);
      params.import_view = {
        title,
        sheet_name,
        format_file,
        columns,
        is_use_advance_report,
      };
      return params;
    },
  },

  watch: {
    form_data_detail(val) {
      const listColumns = Object.keys(val[0].columns);
      const listColumnsVal = Object.values(val[0].columns);

      this.variableOptionsClass = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          if (listColumnsVal[index].type !== '[]attachment') {
            this.variableOptionsClass.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });

            if (listColumnsVal[index].type === 'person') {
              this.variableOptionsClass.push({
                id: `${column}.company_user_id`,
                label: `${column}.company_user_id`,
                text: `${column}.company_user_id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.email`,
                label: `${column}.email`,
                text: `${column}.email`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'object') {
              this.variableOptionsClass.push({
                id: `${column}.id`,
                label: `${column}.id`,
                text: `${column}.id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'timer') {
              this.variableOptionsClass.push({
                id: `${column}.state`,
                label: `${column}.state`,
                text: `${column}.state`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.duration`,
                label: `${column}.duration`,
                text: `${column}.duration`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'tags') {
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.background`,
                label: `${column}.background`,
                text: `${column}.background`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.font_color`,
                label: `${column}.font_color`,
                text: `${column}.font_color`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'maps') {
              this.variableOptionsClass.push({
                id: `${column}.latitude`,
                label: `${column}.latitude`,
                text: `${column}.latitude`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.longitude`,
                label: `${column}.longitude`,
                text: `${column}.longitude`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.address`,
                label: `${column}.address`,
                text: `${column}.address`,
                type: listColumnsVal[index].type,
              });
            }
          }
        });
      }

      if (this.formDetail.import_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.import_view));
        const { title, sheet_name, format_file, is_use_advance_report } = data;
        this.dataSetup.title = title;
        this.dataSetup.sheet_name = sheet_name;
        this.dataSetup.format_file = this.advanceReportSetting ? (is_use_advance_report ? 'csv' : format_file) : (format_file === 'csv' ? null : format_file);
        this.dataSetup.is_use_advance_report = this.advanceReportSetting ? is_use_advance_report : false;

        if (this.formDetail.import_view.columns && this.formDetail.import_view.columns.length > 0) {
          this.dataSetup.columns = [];
          this.formDetail.import_view.columns.forEach((column) => {
            this.dataSetup.columns.push({
              name: column.name,
              key: column.key,
            });
          });
        }
      } else {
        this.dataSetup = {
          title: null,
          sheet_name: null,
          format_file: null,
          active: false,
          columns: [],
          is_use_advance_report: false,
        };
      }
    },

    'dataSetup.title': function (val) {
      setTimeout(() => {
        this.dataSetup.title = val.replace(' ', '_');
      }, 1);
    },

    'dataSetup.sheet_name': function (val) {
      setTimeout(() => {
        this.dataSetup.sheet_name = val.replace(' ', '_');
      }, 1);
    },

    'dataSetup.is_use_advance_report': function (val) {
      if (!this.isLoading) {
        this.setChangesValueView(true);
        this.dataSetup.format_file = val ? 'csv' : null;
      }
    },
  },

  async created() {
    if (this.formDetail.form_data_id) {
      const dataFilter = {
        id: [this.formDetail.form_data_id],
      };
      const param = {
        limit: 0,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      await this.getDataAdvanceReport();
      await this.actionGetDetailFormData(param);
      this.isLoading = false;
    } else {
      await this.getDataAdvanceReport();
      await this.setExternalUrl();
      this.isLoading = false;
    }
  },

  methods: {
    ...mapActions('jStoreFormUi', ['actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm', 'actionSetMultiForm', 'actionGetDetailFormData']),
    ...mapActions('jStoreSetting', ['actionGetUserCompanySetting']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    setExternalUrl() {
      const listColumns = Object.keys(this.formDetail.data_source.external_url.columns);
      const listColumnsVal = Object.values(this.formDetail.data_source.external_url.columns);

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          this.variableOptionsClass.push({
            id: column,
            label: column,
            text: column,
            type: listColumnsVal[index].type,
          });
        });
      }

      if (this.formDetail.import_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.import_view));
        const { title, sheet_name, format_file, is_use_advance_report } = data;
        this.dataSetup.title = title;
        this.dataSetup.sheet_name = sheet_name;
        this.dataSetup.format_file = this.advanceReportSetting ? (is_use_advance_report ? 'csv' : format_file) : (format_file === 'csv' ? null : format_file);
        this.dataSetup.is_use_advance_report = this.advanceReportSetting ? is_use_advance_report : false;

        if (this.formDetail.import_view.columns && this.formDetail.import_view.columns.length > 0) {
          this.dataSetup.columns = [];
          this.formDetail.import_view.columns.forEach((column) => {
            this.dataSetup.columns.push({
              name: column.name,
              key: column.key,
            });
          });
        }
      }
    },

    async getDataAdvanceReport() {
      const { data, error } = await this.actionGetUserCompanySetting(false);
      if (!error) this.advanceReportSetting = !!data.advance_report;
    },

    deleteField(index) {
      this.dataSetup.column.splice(index, 1);
    },

    addColumn() {
      this.dataSetup.columns.push({
        name: null,
        key: null,
      });
      this.setChangesValueView(true);
    },

    deleteColumn(index) {
      this.dataSetup.columns.splice(index, 1);
      this.setChangesValueView(true);
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.formDetail.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            let res;
            if (!this.isMultipleForm) {
              res = await this.actionSetForm(this.genData);
            } else {
              res = await this.actionSetMultiForm(this.genData);
            }
            if (!res.error) {
              this.setChangesValueView(false);
              const dataFilter = {
                id: [this.$route.params.id],
              };
              const param = {
                limit: 0,
                page: 1,
                filter: JSON.stringify(dataFilter),
              };
              if (!this.isMultipleForm) {
                await this.actionGetDetailForm(param);
              } else {
                await this.actionGetDetailMultiForm(param);
              }
            }
          }
        });
      } else {
        this.scrollToErrorField('error-input');
      }
    },

    async deleteView() {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this view?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = this._.cloneDeep(this.formDetail);
          params.import_view = null;
          this.dataSetup = {
            title: null,
            sheet_name: null,
            format_file: null,
            active: false,
            columns: [],
          };

          let res;
          if (!this.isMultipleForm) {
            res = await this.actionSetForm(params);
          } else {
            res = await this.actionSetMultiForm(params);
          }
          if (!res.error) {
            this.setChangesValueView(false);
            const dataFilter = {
              id: [this.$route.params.id],
            };
            const param = {
              limit: 0,
              page: 1,
              filter: JSON.stringify(dataFilter),
            };
            if (!this.isMultipleForm) {
              await this.actionGetDetailForm(param);
            } else {
              await this.actionGetDetailMultiForm(param);
            }
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/menu/jImportView.vue